import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ModsView from '../views/ModsView.vue'
import ModView from '../views/ModView.vue'
import WelcomeView from "@/views/WelcomeView.vue";
import NotFoundView from '@/views/NotFoundView.vue'
import {adminGuard, guard} from "@/router/middleware";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
    {
      path: '/',
      name: 'welcome',
      component: WelcomeView,
    },
    {
      path: '/mods/:game',
      name: 'mods',
      component: ModsView,
    },
    {
      path: '/community',
      name: 'community',
      component: () => import('../views/NewsView.vue'),
    },
    {
      path: '/account',
      name: 'account',
      beforeEnter: (to, from, next) => {
        guard(next)
      },
      component: () => import('../views/ProfileView.vue'),
    },
    {
      name: 'mod',
      path: '/mods/:game/:slug',
      component: ModView,
    },
    {
      name: 'community_news',
      path: '/community/:slug',
      component: () => import('../views/NewsPostView.vue'),
    },
    {
      name: 'search',
      path: '/search',
      component: () => import('../views/SearchView.vue'),
    },
    {
      path: '/favorites',
      name: 'favorites',
      beforeEnter: (to, from, next) => {
        guard(next)
      },
      component: () => import('../views/FavoritesView.vue'),
    },
    {
      path: '/notifications',
      name: 'notifications',
      beforeEnter: (to, from, next) => {
        guard(next)
      },
      component: () => import('../views/NotificationsView.vue'),
    },
    {
      path: '/copyright_abuse',
      name: 'copyright_abuse',
      component: () => import ('../views/CopyrightPolicyView.vue'),
    },
    {
      path: '/privacy_policy',
      name: 'privacy_policy',
      component: () => import ('../views/PrivacyPolicyView.vue'),
    },
    {
      path: '/cookie_usage',
      name: 'cookie_usage',
      component: () => import ('../views/CookieUsageView.vue'),
    },
    {
      path: '/about_us',
      name: 'about_us',
      component: () => import ('../views/AboutUsView.vue'),
    },
    {
      path: '/constructor',
      name: 'constructor',
      component: () => import ('../admin/ConstructorView.vue'),
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/news/constructor',
      name: 'news_constructor',
      component: () => import ('../admin/NewsConstructorView.vue'),
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import ('../admin/AdminPanelView.vue'),
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin/archive',
      name: 'archive',
      component: () => import ('../admin/ArchiveVersionsView.vue'),
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin/posts',
      name: 'posts',
      component: () => import ('../admin/PostsView.vue'),
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin/posts/edit/:slug',
      name: 'post_edit',
      component: () => import ('../admin/PostsEditView.vue'),
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin/comments',
      name: 'comments',
      component: () => import ('../admin/CommentsView.vue'),
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    }
    ]
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/AuthView.vue'),
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/DownloadView.vue'),
  },
  { path: '/:pathMatch(.*)*',
    name: '404',
    component: NotFoundView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router
